import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { FaArrowLeft } from 'react-icons/fa';
import * as Ui from './BackNavigation.styles';

interface IBackNavigationProps {
  label: string;
  path: string;
}

export const BackNavigation: FC<IBackNavigationProps> = ({ path, label, ...rest }) => (
  <Ui.Wrapper {...rest}>
    <>
      {label && (
        <Link to={path} style={{ textDecoration: 'none' }}>
          <Ui.BackButton>
            <FaArrowLeft />
            <Ui.Label>{label}</Ui.Label>
          </Ui.BackButton>
        </Link>
      )}
    </>
  </Ui.Wrapper>
);
